const view = "site-consumption-monitoring";

export const siteConsumptionMonitoring = {
  view,
  backLink: `${view}/back-link`,
  insights: `${view}/insights`,
  insightsHeader: `${view}/insights/header`,
};
